Vue.component('AstmDeviceIndexComponent', require('./components/AstmDeviceIndexComponent').default);
Vue.component('AstmDeviceGetComponent', require('./components/AstmDeviceFormComponent').default);
Vue.component('AstmDeviceDataTable', require('./components/partials/AstmDeviceDataTable').default);
Vue.component('AstmDeviceActions', require('./components/partials/AstmDeviceActions').default);
